var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoutingRule = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3328_39404)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 38.0625V30.1875L31.5 19.6875V6.5625",
  stroke: "currentColor",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 30.1875L10.5 19.6875L10.5 6.5625",
  stroke: "currentColor",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.25 11.8125L10.5 6.5625L15.75 11.8125",
  stroke: "currentColor",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.25 11.8125L31.5 6.5625L36.75 11.8125",
  stroke: "currentColor",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3328_39404"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  fill: "white",
  transform: "matrix(-1 0 0 -1 42 42)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoutingRule);
export default ForwardRef;